<template>
    <div>
        <h3 class="section-heading">Campaign Summary</h3>
        <div class="col-12">
            <div class="form-group">
                <table class="table table-bordered" v-if="client.agencies.data">
                    <tbody>
                        <tr>
                            <td>
                                <div class="c__checkbox">
                                    <input type="checkbox" v-model="client.clientDisplayConfig.showCampaignReportButton">
                                    <label>Show Campaign Report Button</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="c__checkbox">
                                    <input type="checkbox" v-model="client.clientDisplayConfig.showCampaignExportPdf">
                                    <label>Show Campaign Export PDF Button</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="c__checkbox">
                                    <input type="checkbox" v-model="client.clientDisplayConfig.showAgentCampaignAdTitle">
                                    <label>Show Agent Campaign Ad Title Field</label>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div class="c__checkbox">
                                    <input type="checkbox" v-model="client.clientDisplayConfig.showAgentCampaignLabel">
                                    <label>Show Agent Campaign Label Field</label>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="allowEditDisplayConfig">
                            <td>
                                <div class="c__checkbox">
                                    <input type="checkbox" v-model="client.clientDisplayConfig.showPropertyUrlField">
                                    <label>Show Property URL Field</label>
                                </div>
                            </td>
                        </tr>
                        <tr v-if="allowEditDisplayConfig">
                            <td>
                                <div class="c__checkbox">
                                    <input type="checkbox" v-model="client.clientDisplayConfig.showAgentLandingPage">
                                    <label>Show Agent Page URL Field</label>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['client', 'canEditDisplayConfig'],
    computed: {
        allowEditDisplayConfig() {
            return this.canEditDisplayConfig();
        }
    }
}
</script>
